<h2 mat-dialog-title>Request / Response</h2>
<mat-dialog-content>
	<div *ngIf="data.orderno || data.created_at" class="mb-2 text-muted small">
		<span *ngIf="data.orderno">Order: {{ data.orderno }}</span>
		<span *ngIf="data.created_at">{{ data.orderno ? ' · ' : '' }}{{ data.created_at | date:'short' }}</span>
	</div>
	<div *ngIf="data.message" class="mb-2">{{ data.message }}</div>
	<ng-container *ngIf="requestJson || responseJson">
		<div class="section-label">Request</div>
		<pre *ngIf="requestJson" class="log-json-pre">{{ requestJson }}</pre>
		<p *ngIf="!requestJson" class="text-muted mb-2">No request data stored for this log entry.</p>
		<div class="section-label mt-3">Response</div>
		<pre *ngIf="responseJson" class="log-json-pre">{{ responseJson }}</pre>
		<p *ngIf="!responseJson" class="text-muted mb-2">No response data stored for this log entry.</p>
	</ng-container>
	<div *ngIf="!requestJson && !responseJson" class="text-muted">No request or response data.</div>
</mat-dialog-content>
<mat-dialog-actions align="end">
	<button mat-button mat-dialog-close>Close</button>
</mat-dialog-actions>
